import { render, staticRenderFns } from "./RedirectHelper.vue?vue&type=template&id=46efd26c"
import script from "./RedirectHelper.vue?vue&type=script&lang=js"
export * from "./RedirectHelper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports